import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store'
import './theme/index.css'
import ElementUI from 'element-ui';
import VueResource from 'vue-resource';
import qwest from 'qwest'
import QRCode from 'qrcode'
    




Vue.config.productionTip = false

// Vue.use(vuerouter)
// Vue.use(store)
Vue.use(QRCode)
Vue.use(ElementUI)
Vue.use(VueResource)
qwest.setDefaultDataType('json')
// qwest.base = window.protocol === 'localhost' ? ('https' + '://mys4s.cn/') : window.protocol + '://mys4s.cn/'
qwest.base = window.localStorage.grey ? 'https://mys4s.cn/grey/' : 'https://mys4s.cn/'
if (window.localStorage.UserTel === '18072755357' || window.localStorage.UserTel === '1515802770300') {
  qwest.base = 'https://mys4s.cn/grey/'
}
if (window.location.href.indexOf('http://mys4s.cn') !== -1) {
  qwest.base = 'http://mys4s.cn/';
} else if (window.location.href.indexOf('https://mys4s.cn') !== -1) {
  qwest.base = 'https://mys4s.cn/';
} else {
  window.isDebug = true;
  window.env = 'common'; // 调试配置  cmblife 招商  alipay  支付宝   wechat  微信   baiduapp  百度  common  综合
  // qwest.base = 'http://test.mys4s.cn/';
  qwest.base = 'https://mys4s.cn/';
  // qwest.base = 'http://mys4s.cn/';
}
window.qwest = qwest

const signData = function (data, path) {
  let array = []
  let key
  let seed = '99754106633f94d350db34d548d6091a'
  for (key in data) {
    if (data[key] !== undefined && key !== 'md5') {
      array.push(data[key] ? (key + '=' + data[key]) : (key + '='))
    }
  }
  array.sort()
  let param = ''
  for (var item of array) {
    if (param != '') {
      param += '&'
    }
    param += item
  }
  param += seed
  param += '/' + path
  let md5 = require('blueimp-md5')
  return md5(param)
}

const MyHttpPlugin = {
  install: function (Vue, options) {
    Vue.prototype.$params = function (param) {
      param = param || {}
      return Object.keys(param).map((key) => {
        return key + '=' + param[key]
      }).join('&')
    }
    Vue.prototype.$request = (path, params) => {
      params = params || {}
      let t = (new Date()).getTime()
      let np = { 
        t: t,
        channel: window.localStorage.channel ? window.localStorage.channel : 'baidu_pc',
        access_token: window.localStorage.AccessToken || '',
        ...params,
      }
      for (let key in np) {
        let val = np[key]
        if (typeof val === 'number') {
          np[key] = val + ''
        }
      }
      let md5 = signData(np, path)
      np['md5'] = md5
      // let req = Object.keys(np).map((key) => {
      //   if (np[key] !== undefined) {
      //     return key + '=' + encodeURIComponent(np[key])
      //   }
      //   return ''
      // }).join('&')
      return qwest.post(path, np, {
        cache: true,
        withCredentials: true
      })
    }
  }
}

Vue.use(MyHttpPlugin)

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
